import React from 'react';
import { Switch, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ControlField from './ControlField';
import { getControlTokens } from './controlTokens';

function ControlSwitch({
  context = 'filterBar',
  checked = false,
  onChange,
  label = 'Stats',
  ariaLabel,
  width = 92,
  sx,
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);
  const trackHeight = Math.max(tokens.height - 10, 14);
  const thumbSize = Math.max(trackHeight - 2, 12);
  const switchWidth = tokens.height + 12;
  const switchOffset = switchWidth - thumbSize - 4;
  const switchTop = (tokens.height - trackHeight) / 2;

  const handleChange = (event) => {
    onChange?.(event, event.target.checked);
  };

  return (
    <ControlField
      context={context}
      width={width}
      sx={{
        height: tokens.height,
        minHeight: tokens.height,
        paddingInline: theme.spacing(tokens.buttonPx),
        justifyContent: 'space-between',
        gap: tokens.gap,
        border: `1px solid ${tokens.borderColor}`,
        borderRadius: `${tokens.radius}px`,
        backgroundColor: tokens.surface,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: tokens.textColor,
          fontSize: tokens.fontSize,
          fontWeight: 600,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
      <Switch
        checked={checked}
        onChange={handleChange}
        size="small"
        inputProps={{ 'aria-label': ariaLabel || label }}
        data-control-kind="switch"
        sx={{
          width: switchWidth,
          height: tokens.height,
          p: 0,
          flexShrink: 0,
          '& .MuiSwitch-switchBase': {
            p: 0,
            m: `${switchTop}px 0 0 2px`,
            color: theme.palette.grey[100],
            '&.Mui-checked': {
              transform: `translateX(${switchOffset}px)`,
              color: theme.palette.common.white,
              '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
              },
            },
          },
          '& .MuiSwitch-thumb': {
            width: thumbSize,
            height: thumbSize,
            boxShadow: 'none',
          },
          '& .MuiSwitch-track': {
            height: trackHeight,
            mt: `${switchTop}px`,
            borderRadius: trackHeight / 2,
            backgroundColor: theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0.26)'
              : 'rgba(255, 255, 255, 0.3)',
            opacity: 1,
          },
        }}
      />
    </ControlField>
  );
}

export default ControlSwitch;
